import { CouponApiV2 } from '../../../../../lib/api/coupon/CouponApiV2';
import { SearchOption } from '../../../../../types/common/table';
import { WidgetProductFilterOption } from '../../../../../types/widget';
import { CouponProductItemV2, CouponProductListOptionV2 } from '../../../../../types/coupons/product';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const couponProductListFetcher =
  (couponId: number) => async (option: SearchOption<WidgetProductFilterOption>) => {
    const productListOption = new CouponProductListOptionV2(option);

    const defaultResult = {
      totalCount: 0,
      products: [],
    };

    const result = checkValidId([option.id, option.brandId])
      ? await CouponApiV2.getCouponProductList(couponId, productListOption)
      : defaultResult;

    return {
      totalCount: result.totalCount,
      list: result.products.map((item) => new CouponProductItemV2(item)),
    };
  };
